import { withPopup } from '../lib/popup';

import UserEmailEditStep from './UserEmailEditStep';

export default withPopup(UserEmailEditStep);
